module.exports = __webpack_public_path__ + "static/HSE_Announcement_Refinancing_Transaction-fbbddb643896e90dd79ee2af28d0b41f.pdf";